import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activitySettingsStatusRoutes: MenuInterface[] = [
    {
        code: 'StatusParameters',
        route: [
            {
                content: '$type/settings/status/list',
                focus: 'empty'
            }, {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ]
    }
];
